import React from 'react';

import { useApplicationContext } from '@common/react/components/Core/Application/Application';

import { UserRole } from '@app/objects/User';

interface UserRoleAccessProps {
	children: React.ReactNode;
	roles: Array<UserRole>;
	notForRoot?: boolean;
	and?: boolean;
	or?: boolean;
}

const UserRoleAccess: React.FC<UserRoleAccessProps> = (props: UserRoleAccessProps) => {
	const {
		roles, notForRoot, and = true, or = false, children,
	} = props;

	const { checkUserAccess } = useApplicationContext();

	return <>
		{((checkUserAccess(roles, { notForRoot }) && and) || or) && children}
	</>;
};

export default UserRoleAccess;
